// font-preview.js
let previewTimeout;
let isPreviewOpen = false;

function createFontPreviews(translatedText) {
  clearTimeout(previewTimeout);

  previewTimeout = setTimeout(() => {
    const previewContainer = document.createElement("div");
    previewContainer.id = "fontPreviewContainer";
    previewContainer.className = "font-preview-grid";

    const toggleButton = document.createElement("button");
    toggleButton.textContent = "Hide Font Options";
    toggleButton.className = "toggle-preview-button";
    toggleButton.onclick = togglePreview;

    previewContainer.style.cssText = `
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
      gap: 10px;
      padding: 10px;
      margin: 10px 0;
      max-height: 300px;
      overflow-y: auto;
    `;

    // Remove existing preview if any
    const existingPreview = document.getElementById("fontPreviewContainer");
    if (existingPreview) {
      existingPreview.remove();
    }

    // Get fonts from your selector
    const fontSelector = document.getElementById("fontSelector");
    const options = Array.from(fontSelector.options);
    options.forEach((option) => {
      if (option.value && option.value !== "Arial") {
        const previewBox = document.createElement("div");
        previewBox.className = "font-preview-box";
        previewBox.style.cssText = `
          border: 1px solid #ddd;
          border-radius: 8px;
          padding: 15px;
          text-align: center;
          cursor: pointer;
          transition: all 0.3s ease;
          background: white;
        `;

        previewBox.innerHTML = `
          <div style="font-family: ${option.value}; font-size: 20px; margin-bottom: 5px;">
            ${translatedText}
          </div>
          <div style="font-size: 12px; color: #666;">
            ${option.text}
          </div>
        `;

        previewBox.onclick = () => {
          fontSelector.value = option.value;
          updateFont();
          document.querySelectorAll(".font-preview-box").forEach((box) => {
            box.style.border = "1px solid #ddd";
          });
          previewBox.style.border = "2px solid #c7ab62";
          togglePreview();
        };

        previewContainer.appendChild(previewBox);
      }
    });

    // Insert after input field
    const inputField = document.getElementById("inputField");
    inputField.parentElement.insertBefore(toggleButton, inputField.nextSibling);
    inputField.parentElement.insertBefore(
      previewContainer,
      toggleButton.nextSibling
    );

    isPreviewOpen = true;
  }, 2000);
}

function togglePreview() {
  const previewContainer = document.getElementById("fontPreviewContainer");
  const toggleButton = document.querySelector(".toggle-preview-button");

  if (isPreviewOpen) {
    previewContainer.style.display = "none";
    toggleButton.textContent = "Show Font Options";
  } else {
    previewContainer.style.display = "grid";
    toggleButton.textContent = "Hide Font Options";
  }

  isPreviewOpen = !isPreviewOpen;
}




